export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-300">
      <div className="section-container py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-fill text-white text-lg"></i>
              </span>
              <span className="font-heading font-bold text-white text-lg">68影院</span>
            </div>
            <p className="text-background-400 text-sm leading-relaxed">
              你的私人电影大全。最新电影高清免费在线观看，热门电影排行榜每日更新，找片看片一站搞定。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2">
              <a href="#ranking" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">热播排行</a>
              <a href="#index" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">分类索引</a>
              <a href="#media" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">精彩预告</a>
              <a href="#carousel" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">精选专题</a>
              <a href="#about" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap">关于我们</a>
            </nav>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-4">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {['最新电影', '电影排行榜', '高清电影', '免费在线观看', '科幻片', '悬疑片'].map((tag) => (
                <span key={tag} className="px-2.5 py-1 bg-background-800 text-background-400 rounded text-xs whitespace-nowrap">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm mb-4">合作伙伴</h4>
            <p className="text-background-500 text-sm">合作伙伴信息即将上线，敬请期待。</p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-8 md:mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; 2018 - 2026 68影院 All Rights Reserved. 电影大全 | 最新电影高清免费在线观看
          </p>
          <p className="text-background-600 text-xs">
            本站内容仅供学习交流，请支持正版影视作品
          </p>
        </div>
      </div>
    </footer>
  );
}